import { ApiParticipant } from '@api/model/api-participant';
import { ActivityType, activityTypeList } from '@model/activity-type';
import { Participant } from '@model/participant';

/**
 * Converts an API participant response to the internal Participant model.
 *
 * Validates the `activity` field against the known `ActivityType` values
 * and falls back to `undefined` for unrecognized values.
 *
 * @param apiParticipant - The raw API participant object to convert.
 * @returns A `Participant` with a validated `activity` field.
 */
export const convertApiParticipant = (
  apiParticipant: ApiParticipant,
): Participant => ({
  ...apiParticipant,
  activity: activityTypeList.includes(apiParticipant.activity as ActivityType)
    ? (apiParticipant.activity as ActivityType)
    : undefined,
});
